import { List } from 'immutable';
import { DesignTemplates } from 'records/DesignTemplate';
import BaseList from 'records/BaseList';

import {
  FOOD_TYPE_DESIGN_TEMPLATES_ASYNC_ACTION_START,
  FOOD_TYPE_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR,
  FOOD_TYPE_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS,
  FOOD_TYPE_DESIGN_TEMPLATES_RESET_STATE,
} from 'actions/foodTypeDesignTemplates';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [FOOD_TYPE_DESIGN_TEMPLATES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [FOOD_TYPE_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [FOOD_TYPE_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: DesignTemplates(action.data),
    });
  },
  [FOOD_TYPE_DESIGN_TEMPLATES_RESET_STATE]: () => {
    return initialState;
  },
};

export default function foodTypeDesignTemplates(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
